module.exports = __webpack_public_path__ + "static/media/ablogo.922c710f.svg";